import styled from '@emotion/styled';
import type { ObjectId } from '@racemap/sdk/schema/base';
import { type FC, useState } from 'react';
import { useStore } from '../../../store/reducers';
import { EditableTextField } from '../../BasicComponents/EditableTextField';
import { IconPlus } from '../../Icon';

interface Props {
  trackers: Array<ObjectId>;
  buttonLabel: string;
  color?: string;
}

export const AddTrackerTagButton: FC<Props> = ({ trackers, buttonLabel, color = 'black' }) => {
  const { addTrackerTag } = useStore((s) => s.trackers.actions);
  const [isAddingNewTracker, setIsAddingNewTracker] = useState(false);

  const handleNewTag = (label: string) => {
    if (label.trim().length > 0) {
      addTrackerTag(trackers, label);
    }
    setIsAddingNewTracker(false);
  };

  if (isAddingNewTracker) {
    return (
      <EditableTextField
        isEditable
        placeholder="Tag Label"
        onSave={(label: string) => handleNewTag(label)}
        onCancel={() => setIsAddingNewTracker(false)}
        onEditStateChange={(isEditable) => setIsAddingNewTracker(isEditable)}
      />
    );
  }

  return (
    <AddButton onClick={() => setIsAddingNewTracker(true)} color={color}>
      <IconPlus />
      {buttonLabel}
    </AddButton>
  );
};

const AddButton = styled.div<{ color: string }>`
  margin-left: 4px;
  cursor: pointer;
  color: ${(props) => props.color};

  svg {
    margin-right: 5px;
  }
`;
